import { render, staticRenderFns } from "./roleListing.vue?vue&type=template&id=ace2faa4&scoped=true&"
import script from "./roleListing.vue?vue&type=script&lang=js&"
export * from "./roleListing.vue?vue&type=script&lang=js&"
import style0 from "./roleListing.vue?vue&type=style&index=0&id=ace2faa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace2faa4",
  null
  
)

export default component.exports